module.exports = require(process.env.REACT_APP_TARGET === 'server'
    ? './grylls.server'
    : './grylls');
